(() => {
  OnElementLoad = (selector, callback) => {
    var loaded = false;
    var timer = setInterval(() => {
      let $selector = document.querySelectorAll(selector);
      if ($selector.length) {
        console.log(selector + ' loaded!');
        loaded = true;
      }

      if (loaded) {
        clearInterval(timer);
        callback($selector);
      }
    }, 100);
  }  

  const SelectSize = () => {
    let UpdateForm = ($form) => {
      let $selectedSize = $form.querySelector('input:checked');

      $form.querySelectorAll('button[name=add]').forEach(($btnAtc) => {
        $btnAtc.disabled = !$selectedSize;
        $btnAtc.querySelector('[data-add-to-cart-text]').textContent = !$selectedSize ? 'Select Size' : 'Add To Cart';
      });
    }

    document.querySelectorAll('.variant-input-wrap[data-handle="size"]').forEach(($sizeWrap) => {
      // Remove selected size
      $sizeWrap.querySelectorAll('input:checked').forEach(($selectedSize) => {
        $selectedSize.checked = false;
      });

      let $form = $sizeWrap.closest('form');
      UpdateForm($form);

      $sizeWrap.addEventListener('change', (e) => {
        let $target = e.target;
        let isSizeSwatch = $target.getAttribute('name') == 'Size';
        if (isSizeSwatch) {
          UpdateForm($form);
        }
      });
    });
  }

  const StickySelectSize = () => {
    let UpdateForm = ($stickyBar) => {
      let $select = $stickyBar.querySelector('select');
      let size_selected = $select.value !== '';

      $stickyBar.querySelectorAll('.addtc-sticky-btn').forEach(($btnAtc) => {
        $btnAtc.disabled = !size_selected;
        $btnAtc.textContent = !size_selected ? 'Select Size' : 'Add To Cart';
        $btnAtc.classList.toggle('disabled', !size_selected);
      });
    }

    OnElementLoad('#addtc-sticky-bar', ($stickyBar) => {
      setTimeout(() => {
        $stickyBar = $stickyBar[0];
        $stickyBar.querySelectorAll('select').forEach(($select) => {
          $select.insertAdjacentHTML('afterbegin', '<option value="">Select Size</option>');
          $select.value = '';
  
          $select.addEventListener('change', (e) => {
            UpdateForm($stickyBar);
          });

          UpdateForm($stickyBar);
        });        
      }, 500);
    });
  }


  const DOMReady = () => {
    console.log('ready');    
    SelectSize();
    StickySelectSize();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();